<div [hidden]="!CurrentScreenOption.IsVisible" class="CPQComponent">
  <label [htmlFor]="CurrentScreenOption.ID" [ngClass]="{'invalid' : !CurrentScreenOption.IsValid}">{{CurrentScreenOption.Caption + " " + CurrentScreenOption.Description}}</label>

  <select [id]="CurrentScreenOption.ID" [ngModel]="CurrentScreenOption.Value" [disabled]="!CurrentScreenOption.IsEnabled" [required]="CurrentScreenOption.IsRequired" (change)="onDropdownChange($event,CurrentScreenOption.AutoContinueMode)">
    <option *ngFor="let opt of Range"
            selected="{{CurrentScreenOption.Value == opt.value}}"
            [value]="opt.value"
            key="opt.value">
      {{opt.label}}
    </option>
  </select>
</div>

